const BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Check if the client is on a mobile device (viewport width < 768px).
 */
function isMobile() {
  return typeof window !== 'undefined' && window.innerWidth < 768;
}

/**
 * Resolve an image URL to a full absolute URL.
 * Handles /api/uploads/..., /api/images/..., /images/..., and full URLs.
 * Automatically appends ?size=mobile for mobile devices.
 */
export function resolveImageUrl(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;

  const sizeSuffix = isMobile() ? "?size=mobile" : "";

  // /api/uploads/filename.jpg -> /api/images/id (extract id from filename)
  if (url.startsWith("/api/uploads/")) {
    const filename = url.replace("/api/uploads/", "");
    const imageId = filename.includes('.') ? filename.split('.')[0] : filename;
    return `${BASE}/api/images/${imageId}${sizeSuffix}`;
  }

  // /api/images/id -> already correct format
  if (url.startsWith("/api/images/")) {
    return `${BASE}${url}${url.includes('?') ? '' : sizeSuffix}`;
  }

  // /images/dsv-hero.jpg -> /api/images/dsv-hero
  if (url.startsWith("/images/")) {
    const filename = url.replace("/images/", "");
    const imageId = filename.includes('.') ? filename.split('.')[0] : filename;
    return `${BASE}/api/images/${imageId}${sizeSuffix}`;
  }

  // Any other relative path
  return `${BASE}${url}`;
}
